"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueInvoiceDraftEntity = exports.InvoiceDraftPreviewEntity = exports.InvoiceDraftValidationEntity = exports.InvoiceDraftEntity = exports.InvoiceAuthoringIssueEntity = void 0;
class InvoiceAuthoringIssueEntity {
    field;
    code;
    message;
}
exports.InvoiceAuthoringIssueEntity = InvoiceAuthoringIssueEntity;
class InvoiceDraftEntity {
    id;
    kind;
    status;
    version;
    issuer;
    recipient;
    operationDate;
    fiscalRegime;
    lines;
    currency;
    subtotal;
    tax;
    total;
    deliveryEmail;
    sendOnIssue;
    notes;
    originalInvoiceId;
    rectificationReason;
    sourceTransactionId;
    issuedInvoiceIds;
    createdBy;
    updatedBy;
    createdAt;
    updatedAt;
}
exports.InvoiceDraftEntity = InvoiceDraftEntity;
class InvoiceDraftValidationEntity {
    draftVersion;
    valid;
    errors;
    warnings;
}
exports.InvoiceDraftValidationEntity = InvoiceDraftValidationEntity;
class InvoiceDraftPreviewEntity extends InvoiceDraftValidationEntity {
    url;
    expiresAt;
}
exports.InvoiceDraftPreviewEntity = InvoiceDraftPreviewEntity;
class IssueInvoiceDraftEntity {
    draft;
    invoices;
    idempotent;
}
exports.IssueInvoiceDraftEntity = IssueInvoiceDraftEntity;
